import { CommonModule } from '@angular/common';
import { Component, OnInit, Signal, computed, inject } from '@angular/core';
import { ModalContentService } from '../../../shared/modal-content/modal-content.service';
import { ModalContentTypes } from '../../../shared/constants/modal-content-types';
import { ModalContentData } from '../../../shared/modal-content/modal-content';
import { MatIconModule } from '@angular/material/icon';
import { MembershipService } from './membership.service';
import { LocalStorageService } from '../../../shared/local-storage.service';
import { Membership, MembershipData } from './membership.types';
import { Session } from '../../../shared/types/session.type';
import { LOCALSTORAGE_KEYS } from '../../../shared/constants/databases';

@Component({
    selector: 'app-membership',
    imports: [CommonModule, MatIconModule],
    providers: [MembershipService],
    templateUrl: './membership.component.html',
    styleUrl: './membership.component.scss'
})
export class MembershipComponent implements OnInit {
  modalService = inject(ModalContentService);
  membershipService = inject(MembershipService);
  private localStorageService = inject(LocalStorageService);

  membership: Signal<Membership | null> = computed(() => this.membershipService.membership());
  membershipCardsData = computed(() => this.membershipService.membershipList());

  ngOnInit(): void {
    this.getDetails();
  }

  // The CSA deposit step that used to run before this one is a Philly Foodworks
  // concept — its copy names that company — and no plan on this brand takes a
  // deposit, so the flow goes straight to the confirmation with a deposit of 0.
  openModalBecomeAMember(deposit: number, membership: MembershipData) {
    const session: Session | null = this.localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
    if (!session) return;
    this.modalService.openModal(ModalContentTypes.BECOME_A_MEMBER, {
      title: 'Become a member',
      becomeAMemeber: {
        membershipCost: membership.cost,
        creditCardLastNumbers: session?.creditCard?.number.toString(),
        deposit,
        membershipFrequency: membership.renewalType,
        membershipName: membership.name
      }
    } as ModalContentData).closed.subscribe(
      (result: { deposit: number } | null) => {
        if (result && result.deposit >= 0) {
          this.subscribe(result.deposit, false, membership.id);
        }
      }
    )
  }

  openModalCancelMembership() {
    const currentMembership = this.membershipCardsData().find((membership: MembershipData) => membership.id === this.membership()?.id)
    this.modalService.openModal(ModalContentTypes.CONFIRMATION, {
      title: 'Are you sure?',
      textContent: `You are about to cancel your membership and lose all ${currentMembership?.name || 'membership'} benefits.`,
      cancelButtonText: 'Keep membership',
      confirmButtonText: 'Cancel membership',
    }).closed.subscribe(
      (result: { confirm: boolean } | null) => {
        if (result?.confirm) {
          this.cancelMembership();
        }
      }
    )
  }

  subscribe(deposit: number, renew: boolean = false, membershipId?: number) {
    // Without a fee level the backend would fall back to the company default,
    // so drop the call rather than subscribe the customer to the wrong plan.
    if (membershipId == null) return;
    this.membershipService.subscribe(deposit, renew, membershipId);
  }

  private getDetails() {
    this.membershipService.get();
  }

  private cancelMembership() {
    this.membershipService.unsubscribe();
  }

}
